module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "license columns is-multiline"
  }, _vm._l((_vm.licenseData), function(item) {
    return _c('LicenseItem', {
      key: item.id,
      attrs: {
        "license": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddLicense
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить лицензию\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84ba2210"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Documents/License.vue
// module id = 979
// module chunks = 0